import { CustomAttributeEntityType } from '@rematter/frontend-lib-api-client';
import { cn } from '@rematter/ui-web';

import { CustomAttributeField } from './CustomAttribute';

import { useCustomAttributeDefinitionsQuery } from '~/shared/graphql/queries/useCustomAttributeDefinitionsQuery';

export type CustomAttributeFieldsSectionProps = {
  entityType: CustomAttributeEntityType;
  columns?: number;
  className?: string;
  disabled?: boolean;
  values: Record<string, boolean | string | number | null | undefined>;
  onChange: (
    values: Record<string, boolean | string | number | null | undefined>,
  ) => void;
};

export const CustomAttributeFieldsSection = ({
  entityType,
  columns = 1,
  className,
  disabled,
  values,
  onChange,
}: CustomAttributeFieldsSectionProps) => {
  const { data: customAttributeDefinitions } =
    useCustomAttributeDefinitionsQuery({
      entityType,
    });

  const handleFieldChange = (fieldId: string) => (value: unknown) => {
    onChange({
      ...values,
      [fieldId]: value as never,
    });
  };

  return (
    <div
      className={cn('@CustomAttributeFieldsSection', 'grid gap-4', className)}
      style={{
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridTemplateRows: 'auto',
      }}
    >
      {customAttributeDefinitions?.map((attr) => (
        <CustomAttributeField
          key={attr.id}
          definition={attr}
          value={values[attr.id]}
          disabled={disabled}
          onChange={handleFieldChange(attr.id)}
        />
      ))}
    </div>
  );
};
